"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UserDeactivationResourceLog", {
    enumerable: true,
    get: function() {
        return UserDeactivationResourceLog;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _baseresourcelog = require("../base-resource-log");
const UserDeactivationResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resource_type: _zod.z.literal("user-deactivation"),
    change_type: _zod.z.literal("deactivate"),
    data: _zod.z.object({
        /** The ID of the user who was deactivated */ user_id: _zod.z.instanceof(_bson.ObjectId),
        /** The email of the user who was deactivated */ user_email: _zod.z.string(),
        /** The name of the user who was deactivated */ user_name: _zod.z.string(),
        /** The user's role at the time of deactivation */ role: _zod.z.enum([
            "employee",
            "basic_admin",
            "admin",
            "billing_admin"
        ]),
        /** The ID of the user who performed the deactivation (null if system-initiated) */ deactivated_by: _zod.z.instanceof(_bson.ObjectId).nullable(),
        /** The origin/source of the deactivation (e.g., "manual", "scim", "integration") */ origin: _zod.z.string()
    })
});
